import React, { useContext } from "react";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import IOrder from "../../../models/IOrder";
import SupplierContext from "../../../contexts/SupplierContext";
import OrderEntryViewStateOptionsEnum from "../../../models/OrderEntryViewStateOptionsEnum";

type Props = {
    order?: IOrder;
    currentView: OrderEntryViewStateOptionsEnum;
    startPurchaseOrder: () => void;
    hasOnePurchaseOrderRowChecked: () => boolean;
    createPurchaseOrders: (options: {
        useOrderShipToForPoShipTo: boolean;
        autoSubmitPoOnCreate: boolean;
        autoSubmitOrderOnPoEmail: boolean;
        autoSendToQboOnCreate: boolean;
        autoEmailThruQboOnCreate: boolean;
    }) => void;
    cancelPurchaseOrders: () => void;
};

export const OrderEntryPurchaseOrderButtons = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [state, setState] = React.useState({
        useOrderShipToForPoShipTo: true,
        autoSubmitPoOnCreate: false,
        autoSubmitOrderOnPoEmail: false,
        autoSendToQboOnCreate: false,
        autoEmailThruQboOnCreate: false,
    });

    if (
        props.order?.order_state_id === OrderStatesEnum.PRELIMINARY ||
        !supplierModel.has_purchase_orders ||
        !supplierModel.has_create_po_from_orders ||
        props.currentView === OrderEntryViewStateOptionsEnum.BACKORDER
    ) {
        return null;
    }

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.checked;
        setState({
            ...state,
            [name]: value,
        });
    };

    return (
        <div className={"ms-2"}>
            {props.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ? (
                <div>
                    <div>
                        <OwButton
                            title={"create_purchase_orders"}
                            fn={() => {
                                props.createPurchaseOrders(state);
                            }}
                            disabled={!props.hasOnePurchaseOrderRowChecked()}
                        />
                        <OwButton title={"cancel_purchase_orders"} fn={props.cancelPurchaseOrders} className={"ms-2 btn-danger"} />
                    </div>
                    <div className={"mt-4"}>
                        <OwCheckbox
                            name={"useOrderShipToForPoShipTo"}
                            fn={handleChange}
                            checked={state.useOrderShipToForPoShipTo}
                            truthyVal={true}
                            falsyVal={false}
                            label={"use_order_ship_to_for_po_ship_to"}
                        />
                    </div>
                    <div className={"mt-2"}>
                        <OwCheckbox
                            name={"autoSubmitPoOnCreate"}
                            fn={handleChange}
                            checked={state.autoSubmitPoOnCreate}
                            truthyVal={true}
                            falsyVal={false}
                            label={"auto_submit_po_on_create"}
                        />
                    </div>
                    <div className={"mt-2"}>
                        <OwCheckbox
                            name={"autoSubmitOrderOnPoEmail"}
                            fn={handleChange}
                            checked={state.autoSubmitOrderOnPoEmail}
                            truthyVal={true}
                            falsyVal={false}
                            label={"auto_submit_order_on_po_email"}
                        />
                    </div>
                    <div className={"mt-2"}>
                        <OwCheckbox
                            name={"autoSendToQboOnCreate"}
                            fn={handleChange}
                            checked={state.autoSendToQboOnCreate}
                            truthyVal={true}
                            falsyVal={false}
                            label={"auto_send_to_qbo_on_create"}
                        />
                    </div>
                    <div className={"mt-2 mb-4"}>
                        <OwCheckbox
                            name={"autoEmailThruQboOnCreate"}
                            fn={handleChange}
                            checked={state.autoEmailThruQboOnCreate}
                            truthyVal={true}
                            falsyVal={false}
                            label={"auto_email_thru_qbo_on_create"}
                        />
                    </div>
                </div>
            ) : (
                null
            )}
        </div>
    );
    // return <div className={"OrderEntryPurchaseOrderButtons"}></div>;
};
